.row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 18px;
  border-top: 1.5px solid var(--ink);
}

.row:first-child {
  border-top: 0;
}

.main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.who {
  overflow: hidden;
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
}

.detail {
  font-size: 13px;
  color: var(--ink-2);
}

.actions {
  display: flex;
  gap: 8px;
}

.action {
  min-height: 44px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.action:disabled {
  background: var(--sunk);
  color: var(--ink-3);
  cursor: default;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}

.done {
  font-size: 14px;
  font-weight: 600;
}
